<div class="upload-wrapper">
    <div
        *ngIf="!imageChangedEvent"
        class="upload-zone"
        (drop)="onDrop($event)"
        (dragover)="allowDrop($event)"
    >
        <div class="upload-input-wrapper" *ngIf="!currentImage">
            <img src="assets/svg/reusable-svg/upload.svg" alt="upload" />
            <p class="drop-text">
                {{ 'containerImageUpload.dropText' | translate }}
            </p>
            <label class="file-input">
                <input
                    type="file"
                    (change)="onFileChange($event)"
                    accept="image/jpeg"
                />
                {{ 'containerImageUpload.searchText' | translate }}
            </label>
        </div>
        <div class="current-image-wrapper" *ngIf="currentImage">
            <div
                id="container-image-upload-delete-image-button"
                class="delete-image-button"
                (click)="deleteImage()"
                (mouseenter)="deleteButtonHover = true"
                (mouseleave)="deleteButtonHover = false"
            >
                <img
                    [src]="
                        'assets/svg/reusable-svg/icon-trash-can' +
                        (deleteButtonHover ? '-hover' : '') +
                        '.svg'
                    "
                    alt="trashcan-icon"
                />
            </div>
            <img
                class="container-cover-image"
                [src]="currentImage"
                alt="container-image"
            />
        </div>
    </div>

    <div class="cropper-wrapper" *ngIf="imageChangedEvent">
        <div class="upload-cancel-buttons-wrapper">
            <div
                class="button upload"
                id="container-image-upload-upload-button"
                (click)="cropImage()"
            >
                <span>Upload</span>
            </div>
            <div
                class="button cancel"
                (click)="discardCrop()"
                id="container-image-upload-cancel-button"
            >
                <span>Cancel</span>
            </div>
        </div>
        <image-cropper
            [imageChangedEvent]="imageChangedEvent"
            [imageFile]="imageChangedEvent?.target?.files[0]"
            [autoCrop]="false"
            [aspectRatio]="16 / 9"
            [maintainAspectRatio]="true"
            [resizeToWidth]="640"
            output="base64"
            format="jpeg"
            (imageCropped)="imageCropped($event)"
        ></image-cropper>
    </div>
</div>
